<template>
  <div>
    <router-link :to="pathDashboard" id="container"
      class="text-background-academy-600 font-sans-serif">
      <div class="flex justify-start items-start pb-0 lg:pb-10 lg:pb-0 group mx-auto"
        :class="containerClass">
        <img :src="person.urlProfilePhoto ? person.urlProfilePhoto : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png'" alt="foto profilo" id="photo"
          class="rounded-full transform group-hover:scale-110 duration-200"
          :class="photoClass ? photoClass : 'w-10 lg:w-12'">
        <h1 class="hover:border-white w-full
          transform hover:scale-90 duration-300" :class="textClass"
          id="title">{{person.name}}</h1>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['person', 'isTeacher', 'containerClass', 'textClass', 'photoClass'],

  computed: {
    pathDashboard() {
      if (this.isTeacher) {
        return `/teachers/${this.person.slug}`;
      }
      return `/students/${this.person.slug}`;
    },
  },
};
</script>
